import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSolutionSection from './components/ProblemSolutionSection';
import ServicesSection from './components/ServicesSection';
import UrgencySection from './components/UrgencySection';
import AboutSection from './components/AboutSection';
import HowItWorksSection from './components/HowItWorksSection';
import DifferentialsSection from './components/DifferentialsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSolutionSection />
        <ServicesSection />
        <UrgencySection />
        <AboutSection />
        <HowItWorksSection />
        <DifferentialsSection />
        <TestimonialsSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}